// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/index.less
// module id = 25
// module chunks = 0